module.exports = __webpack_public_path__ + "img/sand.5ab8ace9.jpg";